import type { IQrCodeLink } from '../../../../../../shared/types';
import type { DataAction } from '../../../types/dataAction.type';
import { type DuplicateQrCodeLinkPayload, QrCodeLinkAdapterService } from '../services/QrCodeLinkAdapterService';

type Payload = { qrCodeLinkToDuplicate: DuplicateQrCodeLinkPayload };

export const DUPLICATE_QR_CODE_LINK = 'DUPLICATE_QR_CODE_LINK' as const;

export const duplicateQrCodeLink = (qrCodeLink: IQrCodeLink) => {
  const qrCodeLinkAdapter = new QrCodeLinkAdapterService();
  return {
    type: DUPLICATE_QR_CODE_LINK,
    data: { qrCodeLinkToDuplicate: qrCodeLinkAdapter.toDuplicatePayload(qrCodeLink) },
  };
};

export type DuplicateQrCodeLinkResponseAction = DataAction<typeof DUPLICATE_QR_CODE_LINK, Payload>;
